import React from 'react'
import Script from 'next/script'

import * as S from './SearchGCSE.styles'

const defaultProps = {}
const propTypes = {}

export const Search = () => {
  return (
    <S.Container>
      <S.Content>
        {typeof window !== 'undefined' && (
          <>
            <Script
              async
              src="https://cse.google.com/cse.js?cx=028315ce5e1b830ba"
            ></Script>
            <div
              className="gcse-searchresults-only"
              data-refinementStyle="link"
              data-personalizedAds="false"
            ></div>
          </>
        )}
      </S.Content>
    </S.Container>
  )
}

Search.defaultProps = defaultProps
Search.propTypes = propTypes

export default Search
